export function stripQueryParams(url: string) {
	const queryStringIndex = url.indexOf('?');
	return queryStringIndex === -1 ? url : url.substring(0, queryStringIndex);
}
